<!--Loading Spinner-->
<div *ngIf="isLoading">
  <app-spinner></app-spinner>
</div>
<!-- Content Header (Page header) -->
<section class="content-header">
  <div class="content-header">
     <div class="container-fluid">
       <div class="row mb-2">
         <div class="col-sm-6">
             <h3>Update Port Charges Payments</h3>
         </div>
         <div class="col-sm-6">
           <ol class="breadcrumb float-sm-right">
             <li class="breadcrumb-item"><a href="/"><i class="nav-icon fas fa-tachometer-alt"></i>&nbsp;Dashboard</a></li>
             <li class="breadcrumb-item active">Update Port Charges Payments</li>
           </ol>
         </div><!-- /.col -->
       </div><!-- /.row -->
     </div><!-- /.container-fluid -->
 </div>
 </section>
   <!-- /.content-header -->
 <section class="content">
 <div class="container-fluid">
 <div class="card">
     <div class="card-header">
       <h3 class="card-title">Payment Details</h3>
        <!--Error message-->
        <div class="alert alert-danger alert-dismissible fade show" role="alert" *ngIf="errorMessage">
          {{errorMessage}}
          <button type="button" class="close" data-dismiss="alert" aria-label="Close">
              <span aria-hidden="true">&times;</span>
          </button>
      </div>
     </div>
     <!-- /.card-header -->
     <div class="card-body">
        <form [formGroup]="form" (ngSubmit)="handleSubmit()">
          <div class="row clearfix">
            <div class="col-md-4">
                <div class="form-group">
                    <label>BL No.:</label>
                    <ng-select [(ngModel)]="selectedBL" [ngModelOptions]="{standalone: true}" (ngModelChange)="onSelectChange($event)">
                      <ng-option *ngFor="let bl of billsOfLading" [value]="bl.bl_no">{{bl.bl_no}}</ng-option>
                    </ng-select>
                </div>
            </div>

            <div class="col-md-4">
                <div class="form-group">
                    <label>Amount:</label>
                    <input type="text" formControlName="amount" class="form-control" placeholder="New D.O amount">

                    <span *ngIf="submitted && form.get('amount')?.hasError('required')" style="color:red"> <strong>Please enter amount!</strong></span>
                </div>
            </div>

            <div class="col-md-4 d-flex align-items-end">
                <button type="submit" class="btn btn-success mb-3"><i
                  class="fas fa-save" aria-hidden="true">&nbsp;</i>Update</button>
            </div>
          </div>
        </form>
        <h3 class="card-title">Current Port Charges Payments</h3>
        <table class="table">
            <tr>
                <th>Make</th>
                <th>Model</th>
                <th>Chassis No.</th>
                <th>Amount</th>
            </tr>
            <tr *ngFor="let vehicle of currPortChargesPayments">
                <td>{{vehicle.make}}</td>
                <td>{{vehicle.model}}</td>
                <td>{{vehicle.chassis_no}}</td>
                <td>{{vehicle.amount| currency:'Kshs '}}</td>
            </tr>
        </table>
     </div>
     <!-- /.card-body -->
 </div>
 </div>
 </section>
